// extracted by mini-css-extract-plugin
export var copyIcon = "_sm-2";
export var discountCard = "_sm-0";
export var discountCode = "_sm-3";
export var discountContent = "_sm-1";
export var loadingCard = "_sm-4";